import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import validator from "validator";
import { Formik, Form, Field, ErrorMessage, useFormik } from "formik";
import * as Yup from "yup";
import TextErrorr from "../../layout/TextError";
import AddressSearch, * as loqate from "react-loqate";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import ENUMS from "../../../utils/ENUMS.js";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { getClubDetailForLoggedInUser } from "../../../services/apiService";
import { toast } from "react-toastify";

import { BASE_URL } from "../../../config.json";
import MapBaseLayout from "../../layout/maps/MapBaseLayout.js";

const initialValues = {
  name: "",
  email: "",
  psw_1: "",
  psw_2: "",
  phone: "",
  website: "",
  address: "",
  town: "",
  county: "",
  country: "",
  postcode: "",
  gname: "",
};

const LoadInitValueFromLoacalStorage = async () => {
  if (localStorage.getItem("Renew-Create-ClubDetail")) {
    let localStorageVal = JSON.parse(
      localStorage.getItem("Renew-Create-ClubDetail")
    );
    // console.log(localStorageVal);
    // initialValues['name'] = localStorageVal.name
    // name
    initialValues["name"] = localStorageVal.name;
    // email
    initialValues["email"] = localStorageVal.email;
    // psw_1
    initialValues["psw_1"] = localStorageVal.psw_1;
    // psw_2
    initialValues["psw_2"] = localStorageVal.psw_2;
    // phone
    initialValues["phone"] = localStorageVal.phone;
    // website
    initialValues["website"] = localStorageVal.website;
    // address
    initialValues["address"] = localStorageVal.address;
    // town
    initialValues["town"] = localStorageVal.town;
    // county
    initialValues["county"] = localStorageVal.county;
    // country
    initialValues["country"] = localStorageVal.country;
    // postcode
    initialValues["postcode"] = localStorageVal.postcode;
    // gname
    initialValues["gname"] = localStorageVal.gname;
  }
};

LoadInitValueFromLoacalStorage();

const token = localStorage.getItem(ENUMS.AUTH);

const validationSchema = Yup.object({
  name: Yup.string().required("Required!"),
  email: Yup.string().email("Invalid email address").required("Required!"),
  phone: Yup.string().required("Required!"),
  website: Yup.string()
    .matches(
      /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
      "Enter correct url!"
    )
    .required("Please enter website"),
  address: Yup.string().required("Required!"),
  town: Yup.string().required("Required!"),
  country: Yup.string().required("Required!"),
  postcode: Yup.string().required("Required!"),
  gname: Yup.string().required("Required!"),
});

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Required";
  }
  if (!values.gname) {
    errors.gname = "Required";
  }

  if (!values.phone) {
    errors.phone = "Required";
  } else if (!/^\d{10}$/.test(values.phone)) {
    errors.phone = "Invalid Mobile Number";
  }

  if (!values.email) {
    errors.email = "Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.town) {
    errors.town = "Required";
  }

  if (!values.postcode) {
    errors.postcode = "Required";
  }

  if (!values.country) {
    errors.country = "Required";
  }

  if (!values.website) {
    errors.website = "Required";
  } else if (!validator.isURL(values.website)) {
    errors.website = "not valid";
  }

  if (!values.county) {
    errors.county = "Required";
  }

  return errors;
};
let List = [];

const RenewClubDetails = (props) => {
  const [initValll, SetinitValll] = useState(initialValues);

  const [Submit, SetSubmit] = useState(false);
  const [Data, getData] = useState([]);
  const Get_List = () => {
    axios
      .get(
        `${BASE_URL}/club/get_clubs/`
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`
        //   },
        // }
      )
      .then((res) => {
        List.push(res.data.data);
        getData(List);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const HandleChange = (e) => {
    console.log(e.target.value, "GET VALUE");
  };

  const storeClubDetailsInLocalStorage = (values) =>
    localStorage.setItem("Renew-Create-ClubDetail", JSON.stringify(values));

  const checkClubDetailsRemoveLocalStorageItem = () =>
    localStorage.getItem("Renew-Create-ClubDetail") &&
    localStorage.removeItem("Renew-Create-ClubDetail");

  let history = useHistory();

  const getClubDetails = async () => {
    let clubData = await getClubDetailForLoggedInUser(token);
    if (
      clubData.status == 200 ||
      clubData.data.status == "SUCCESS" ||
      clubData.data.errMsg == null
    ) {
      initialValues["name"] = clubData.data.data.user.first_name;
      // email
      initialValues["email"] = clubData.data.data.user.email;
      // phone
      initialValues["phone"] = clubData.data.data.club_profile.phone_no;
      // website
      initialValues["website"] = clubData.data.data.club_profile.website_url;
      // address
      initialValues["address"] =
        clubData.data.data.club_address.address1 +
        "," +
        clubData.data.data.club_address.address2;
      // town
      initialValues["town"] = clubData.data.data.club_address.town;
      // county
      initialValues["county"] = clubData.data.data.club_address.county;
      // country
      initialValues["country"] = clubData.data.data.club_address.country;
      // postcode
      initialValues["postcode"] = clubData.data.data.club_address.post_code;
      // gname
      initialValues["gname"] = clubData.data.data.club_profile.golfclub;
    }
  };

  useEffect(() => {
    if (localStorage.getItem("Renew-Create-ClubDetail")) {
      LoadInitValueFromLoacalStorage();
    } else {
      getClubDetails().then();
    }
    SetinitValll(initialValues);
    Get_List();
  }, []);
  const formik = useFormik({
    initialValues: initValll,
    validate,
    onSubmit: (values) => {
      SetSubmit(true);
      storeClubDetailsInLocalStorage(values);
      // history.push("/golf-courses");
      props.SetScreenPostion(2);
    },
    enableReinitialize: true,
  });
  const [data, setData] = useState([]);

  const search = (key) => {
    console.log(key);
    fetch(`${BASE_URL}/club/get_clubs/?chars=` + key).then((data) => {
      data.json().then((resp) => {
        console.log("resp", resp.data);
      });
    });
  };
  const AddressSearchInput = (props) => {
    return (
      <input
        style={{
          padding: "1.7rem 5rem 1.7rem 5rem",
          borderRadius: "4rem",
          border: "none",
          fontSize: "calc(2.2rem * var(--fz))",
          lineHeight: "calc(5.1rem * var(--fz))",
          fontWeight: "500",
          fontFamily: "var(--ff-jost)",
          color: "var(--clr-white)",
          letterSpacing: "1px",
          background: "var(--clr-primary)",
          width: "100%",
          height: "6.7rem",
        }}
        placeholder="Start to type your address…"
        autocomplete="on"
        name="address"
        onChange={formik.handleChange}
        value={formik.address}
        {...props}
      />
    );
  };

  return (
    <>
      <div className="cdetail">
        <h1 className="login-title text-jost-sb-50-wt">
          Renew your club membership
        </h1>

        <div className="cdetail__wrap">
          <div className="cdetail__bar">
            <ul className="cdetail__bar__row">
              <li className="text-jost-sb-22 active ">CLUB Details</li>
              <li className="text-jost-sb-22">Golf Courses</li>
              <li className="text-jost-sb-22">Payment DETAILS</li>
              <li className="text-jost-sb-22">Confirmation</li>
            </ul>
          </div>
          <Formik
            initialValues={initValll}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            <form onSubmit={formik.handleSubmit} className="cdetail__box">
              <div className="cdetail__box__left">
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Contact NAME*"
                    name="name"
                    onChange={formik.handleChange}
                    value={formik.values.name}
                  />
                  {formik.errors.name ? (
                    <div style={{ color: "red" }}>* {formik.errors.name}</div>
                  ) : null}
                </div>
                <div className="errors__container">
                  <datalist id="gname">
                    {Data.map((data) => {
                      return data.map((user) => {
                        return (
                          <>
                            <option value={user.club_name}>{+user.id}</option>
                          </>
                        );
                      });
                    })}
                  </datalist>

                  {console.log(formik.values)}

                  <input
                    list="gname"
                    name="gname"
                    type="text"
                    onChange={formik.handleChange}
                    value={formik.values.gname}
                    placeholder="GOLF Club Name*"
                    className="form__input-md"
                  />
                  {formik.errors.gname ? (
                    <div style={{ color: "red" }}>* {formik.errors.gname}</div>
                  ) : null}

                  <div>
                    {data.map((data) => {
                      return <div>{}</div>;
                    })}
                  </div>
                </div>
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="email"
                    placeholder="email address*"
                    name="email"
                    onChange={formik.handleChange}
                    value={formik.values.email}
                  />
                  {formik.errors.email ? (
                    <div style={{ color: "red" }}>* {formik.errors.email}</div>
                  ) : null}
                </div>
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="number"
                    placeholder="Phone Number*"
                    name="phone"
                    onChange={formik.handleChange}
                    value={formik.values.phone}
                  />
                  {formik.errors.phone ? (
                    <div style={{ color: "red" }}>* {formik.errors.phone}</div>
                  ) : null}
                </div>
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Website URL"
                    name="website"
                    onChange={formik.handleChange}
                    value={formik.values.website}
                  />
                  {formik.errors.website ? (
                    <div style={{ color: "red" }}>
                      * {formik.errors.website}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="cdetail__box__right">
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="address"
                    name="address"
                    onChange={formik.handleChange}
                    value={formik.values.address}
                  />
                  {formik.errors.address ? (
                    <div style={{ color: "red" }}>
                      * {formik.errors.address}
                    </div>
                  ) : null}
                </div>

                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Town"
                    name="town"
                    onChange={formik.handleChange}
                    value={formik.values.town}
                  />
                  {formik.errors.town ? (
                    <div style={{ color: "red" }}>* {formik.errors.town}</div>
                  ) : null}
                </div>
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="County*"
                    name="county"
                    onChange={formik.handleChange}
                    value={formik.values.county}
                  />
                  {formik.errors.county ? (
                    <div style={{ color: "red" }}>* {formik.errors.county}</div>
                  ) : null}
                </div>
                <div className="custom-select-wrapper">
                  <div>
                    <div>
                      <select
                        className="form__input-md"
                        onChange={formik.handleChange}
                        value={formik.values.country}
                        placeholder={formik.values.country}
                        name="country"
                        id="cars"
                      >
                        <option value="" selected>
                          {formik.values.country
                            ? formik.values.country
                            : "COUNTRY *"}
                        </option>
                        <option value="India">India</option>
                        <option value="USA">USA</option>
                        <option value="UK">UK</option>
                      </select>
                      {formik.errors.country ? (
                        <div style={{ color: "red" }}>
                          * {formik.errors.country}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="errors__container">
                  <input
                    className="form__input-md"
                    type="text"
                    placeholder="Postcode*"
                    name="postcode"
                    onChange={formik.handleChange}
                    value={formik.values.postcode}
                  />
                  {formik.errors.postcode ? (
                    <div style={{ color: "red" }}>
                      * {formik.errors.postcode}
                    </div>
                  ) : null}
                </div>
                <div className="cdetail__box__right-links">
                  <button type="submit" className="res-btn-primary">
                    NEXT
                  </button>
                </div>
              </div>
            </form>
          </Formik>
        </div>
      </div>
    </>
  );
};

export default RenewClubDetails;
